import {
  observableFetchClient,
  createAuthorizationHeaders,
} from '@vp/common-api-utils';
import { getAuthHeaderAndShopperId } from '@vp/common-api-utils/authHelpers';

const VISTACART_URL = process.env.VISTACART_BASE_URL; // 'http://localhost:8080';
const { VISTACART_TIMEOUT_MS } = process.env;

const vistacartTimeoutMs = VISTACART_TIMEOUT_MS
  ? parseInt(VISTACART_TIMEOUT_MS)
  : 10000;

const buildVistacartApiParams = () => ({
  requestor: 'cartui',
});

export function getVistaCartUrl() {
  return VISTACART_URL;
}

export function getShopperCart(
  tenant: string,
  shopperId: string,
  shouldLoadOffline?: boolean
) {
  const { authHeader } = getAuthHeaderAndShopperId();
  let url = `${VISTACART_URL}/tenants/${tenant}/carts/${shopperId}`;
  if (shouldLoadOffline) {
    url += `/offline`;
  }
  return observableFetchClient({
    url,
    params: buildVistacartApiParams(),
    method: 'get',
    headers: createAuthorizationHeaders(authHeader),
    timeout: vistacartTimeoutMs,
    maxAttempts: 2,
  }).then(res => res.json());
}

export function removeCartItem(
  tenant: string,
  shopperId: string,
  itemId: string
) {
  const { authHeader } = getAuthHeaderAndShopperId();
  return observableFetchClient({
    url: `${VISTACART_URL}/tenants/${tenant}/carts/${shopperId}/items/${itemId}`,
    params: buildVistacartApiParams(),
    method: 'delete',
    headers: createAuthorizationHeaders(authHeader),
    timeout: vistacartTimeoutMs,
    maxAttempts: 2,
  });
}

export function removeCartItemGroup(
  tenant: string,
  shopperId: string,
  groupId: string
) {
  const { authHeader } = getAuthHeaderAndShopperId();
  return observableFetchClient({
    url: `${VISTACART_URL}/tenants/${tenant}/carts/${shopperId}/itemgroups/${groupId}`,
    params: buildVistacartApiParams(),
    method: 'delete',
    headers: createAuthorizationHeaders(authHeader),
    timeout: vistacartTimeoutMs,
    maxAttempts: 2,
  });
}

export function updateLineItemQuantity(
  tenant: string,
  shopperId: string,
  itemId: string,
  newQuantity: number
) {
  const { authHeader } = getAuthHeaderAndShopperId();
  return observableFetchClient({
    url: `${VISTACART_URL}/tenants/${tenant}/carts/${shopperId}/items/${itemId}/quantity/${newQuantity}`,
    params: buildVistacartApiParams(),
    method: 'post',
    headers: createAuthorizationHeaders(authHeader),
    timeout: vistacartTimeoutMs,
    maxAttempts: 2,
  });
}

export function refreshPricing(tenant: string, shopperId: string) {
  const { authHeader } = getAuthHeaderAndShopperId();
  return observableFetchClient({
    url: `${VISTACART_URL}/tenants/${tenant}/carts/${shopperId}/refreshCart`,
    params: buildVistacartApiParams(),
    method: 'post',
    headers: createAuthorizationHeaders(authHeader),
    timeout: vistacartTimeoutMs,
    maxAttempts: 2,
  });
}
